var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 7.33333H0V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0L7.33333 0V7.33333ZM1.33333 6H6V1.33333H2C1.82319 1.33333 1.65362 1.40357 1.5286 1.5286C1.40357 1.65362 1.33333 1.82319 1.33333 2V6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7.33333H8.66666V0H14C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V7.33333ZM10 6H14.6667V2C14.6667 1.82319 14.5964 1.65362 14.4714 1.5286C14.3464 1.40357 14.1768 1.33333 14 1.33333H10V6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 15.9998H2C1.46957 15.9998 0.960859 15.7891 0.585786 15.4141C0.210714 15.039 0 14.5303 0 13.9998L0 8.6665H7.33333V15.9998ZM1.33333 9.99984V13.9998C1.33333 14.1766 1.40357 14.3462 1.5286 14.4712C1.65362 14.5963 1.82319 14.6665 2 14.6665H6V9.99984H1.33333Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.9998H8.66666V8.6665H16V13.9998C16 14.5303 15.7893 15.039 15.4142 15.4141C15.0391 15.7891 14.5304 15.9998 14 15.9998ZM10 14.6665H14C14.1768 14.6665 14.3464 14.5963 14.4714 14.4712C14.5964 14.3462 14.6667 14.1766 14.6667 13.9998V9.99984H10V14.6665Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.033e6732a1a18828437966fae00e1c37.svg";
export { ForwardRef as ReactComponent };